import { SolutionViolationTypes } from '../../../components/routes/RouteInfo/MiniRouteInfo';
import { Instance } from 'mobx-state-tree';
import getFormattedDistance from '../../../helpers/getFormattedDistance';
import { RouteSolutionDtoModelBase } from './RouteSolutionDtoModel.base';
import { DistanceUnit } from './DistanceUnitEnum';

/* The TypeScript type of an instance of RouteSolutionDtoModel */
export interface RouteSolutionDtoModelType extends Instance<typeof RouteSolutionDtoModel.Type> {}

/* A graphql query fragment builders for RouteSolutionDtoModel */
export { selectFromRouteSolutionDto, routeSolutionDtoModelPrimitives, RouteSolutionDtoModelSelector } from './RouteSolutionDtoModel.base';

/**
 * RouteSolutionDtoModel
 */
export const RouteSolutionDtoModel = RouteSolutionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views((self) => ({
    get workingTimeMinutes(): number | undefined {
      return self.workingTime !== undefined ? Math.floor(self.workingTime / 60) : undefined;
    },
    get isOverCapacity(): boolean {
      return !!self.violations?.some((violation) => violation.type === SolutionViolationTypes.CAPACITY);
    },
    get isOvertime(): boolean {
      return !!self.violations?.some((violation) => violation.type === SolutionViolationTypes.OVERTIME);
    },
  }))
  .views((self) => ({
    get kmsFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.KM, 2);
    },
    get shortKmsFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.KM);
    },
    get milesFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.MILES, 2);
    },
    get shortMilesFromDistance(): number | undefined {
      const { distance } = self;
      return getFormattedDistance(distance, DistanceUnit.MILES);
    },
  }));
